import React from "react";
import { Link } from "react-router-dom";
import { Logo } from "../components/landing/Logo";
import { useAuth } from "../lib/AuthContext";

// Catch-all for any URL that matches no route (see App.js). Without it React
// Router renders nothing at all, i.e. a blank page.
export default function NotFound() {
  const { user } = useAuth();
  return (
    <div className="min-h-screen bg-canvas canvas-grain" data-testid="not-found-page">
      <div className="max-w-7xl mx-auto px-6 md:px-10 pt-8">
        <Logo />
      </div>
      <div className="max-w-md mx-auto px-6 mt-24 text-center">
        <p className="eyebrow">404</p>
        <h1 className="mt-3 font-heading font-semibold text-ink text-[34px] tracking-tight leading-[1.1]">
          We can't find that page.
        </h1>
        <p className="mt-3 font-body text-[15px] text-ink-soft leading-[1.6]">
          The link may be old or mistyped.
        </p>
        <Link
          to={user ? "/dashboard" : "/"}
          data-testid="not-found-home"
          className="mt-8 inline-flex items-center rounded-full bg-navy text-white px-6 py-3 font-body text-[13px] font-medium hover:bg-navy-hover transition-colors"
        >
          {user ? "Back to dashboard" : "Back to home"}
        </Link>
      </div>
    </div>
  );
}
